import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import i18next from "i18next"
import { I18nextProvider } from 'react-i18next';
import trad_en from "./languages/en.json"
import trad_du from "./languages/du.json"
import trad_fr from "./languages/fr.json"
import trad_es from "./languages/es.json"
import trad_it from "./languages/it.json"
import trad_pt from "./languages/pt.json"
import trad_nl from "./languages/nl.json"
import trad_tk from "./languages/tk.json"
import trad_ru from "./languages/ru.json"
import trad_ro from "./languages/ro.json"
import trad_zh from "./languages/zh.json"
import trad_ko from "./languages/ko.json"

i18next.init({
  interpolation: {
    escapeValue: false, // not needed for react!!
  },
  lng: "en",
  resources: {
    en: {
      global: trad_en
    },
    du: {
      global: trad_du
    },
    fr: {
      global: trad_fr
    },
    es: {
      global: trad_es
    },
    it: {
      global: trad_it
    },
    pt: {
      global: trad_pt
    },
    nl: {
      global: trad_nl
    },
    tk: {
      global: trad_tk
    },
    ru: {
      global: trad_ru
    },
    ro: {
      global: trad_ro
    },
    zh: {
      global: trad_zh
    },
    ko: {
      global: trad_ko
    }
  }
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n = {i18next}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);
